import styles from './MandatoryFieldsSubtitle.module.css'

export function MandatoryFieldsSubtitle() {
  return (
    <p className={styles.subtitle}>
      Fields marked with &quot;<span className={styles.asterisk}>*</span>&quot;
      are mandatory
    </p>
  )
}
